<template>
  <div>
    <Header>

    </Header>
    <main>
      <LoginForm></LoginForm>
    </main>
  </div>
</template>


<script>
// @ is an alias to /src
import Header from "@/components/layout/Header.vue";
import LoginForm from "@/components/auth/LoginForm.vue";

export default {
  name: "login",
  components: {
    Header,
    LoginForm
  },
  mounted () {
  }
};
</script>
